import { createBrowserRouter } from 'react-router-dom';
import Layout from '@/layout/MainLayout';
import MainPage from '@/pages/Main';
import LoginPage from '@/pages/Login';
import UsersPage from '@/pages/User';
import Statistic from '@/pages/Statistic';
import { UserLayout } from '@/layout/UserLayout';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import ControlPolicy from '@/pages/ControlPolicy';
import ReqPublisherDetail from '@/pages/RequestDetail';
import PublisherJourneyDetail from '@/pages/RequestDetail/PublisherJourneyDetail';
import PageNotFound from '@/pages/PageNotFound';
import RequestPage from '@/pages/Request';
import ApiManagementPage from '@/pages/Api';
import EmailBlastList from '@/pages/EmailBlastList';
import CreateEmailBlast from '@/pages/CreateEmailBlast';
import AddRecipients from '@/pages/AddRecipients';
import ViewEmailDraft from '@/pages/ViewEmailDraft';
import EditEmailBlast from '@/pages/EditEmailBlast';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <MainPage />,
      },
      {
        path: 'users',
        element: <UserLayout />,
        children: [
          { path: '', index: true, element: <UsersPage /> },
          { path: 'control-policy/:username', element: <ControlPolicy /> },
        ],
      },
      {
        path: 'requests',
        element: <UserLayout />,
        children: [
          { path: '', index: true, element: <RequestPage /> },
          { path: 'detail/:id', element: <PublisherJourneyDetail /> },
          { path: 'control-policy/:username', element: <ReqPublisherDetail /> },
        ],
      },
      {
        path: 'apis',
        element: <UserLayout />,
        children: [
          { path: '', index: true, element: <ApiManagementPage /> },
        ],
      },
      {
        path: 'statistic',
        element: <UserLayout />,
        children: [{ path: '', index: true, element: <Statistic /> }],
      },
      {
        path: 'email-blast',
        element: <UserLayout />,
        children: [
          { path: '', index: true, element: <EmailBlastList /> },
          { path: 'create', element: <CreateEmailBlast /> },
          { path: 'add-recipients', element: <AddRecipients /> },
          { path: 'view/:id', element: <ViewEmailDraft /> },
          { path: 'edit/:id', element: <EditEmailBlast /> },
        ],
      },
      {
        path: '/unauthorize',
        element: <UnauthorizedPage />,
      },
      {
        path: '*',
        element: <PageNotFound />,
      },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
]);
